export function OutlineVistaListaIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3229 0.75C16.3229 1.2913 16.3229 1.83913 16.3229 2.38044C18.6726 1.91087 21.0544 2.88261 22.3354 4.82609C24.067 7.44783 22.8246 10.3565 22.7474 10.5326C22.7731 10.337 23.0371 7.87827 21.1381 6.19566C19.8248 5.03479 17.9838 4.74131 16.3229 5.33479C16.3229 5.89566 16.3229 6.39783 16.3229 6.9587L11.0186 3.84783C12.7888 2.81739 14.5591 1.78044 16.3358 0.75H16.3229Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9877 9.22852H7.23291"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9877 11.8379H7.23291"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.9694 8.90234H0.750732V12.1632H3.9694V8.90234Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6313 14.7715H10.8701"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6313 17.3809H10.8701"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.20695 14.4453H3.98828V17.7062H7.20695V14.4453Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2493 20.3145H14.488"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2493 22.9238H14.488"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4194 19.9883H7.20068V23.2492H10.4194V19.9883Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
